import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from 'common/components';
import { useClassName } from 'common/hooks';
import './styles/cta-button.less';

const CTAButton = ({ text, link, variant, svg }) => {
  const classNames = useClassName('CTAButton');

  return (
    <a href={link} className={classNames(['container', variant])}>
      {text}
      {svg && <SVGIcon name={svg} size="tiny" className={classNames('icon')} />}
    </a>
  );
};

CTAButton.propTypes = {
  text: PropTypes.string.isRequired,
  svg: PropTypes.string,
  link: PropTypes.string.isRequired,
  variant: PropTypes.string,
};

CTAButton.defaultProps = {
  variant: 'primary',
  svg: null,
};

export default CTAButton;
